import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import * as ROUTES from '../../../constants/routes';

import { useFirebase } from '../../../contexts/FirebaseContext';
import { useAuth } from '../../../contexts/AuthContext';
import { AddTrack, DeleteTrack } from '../TrackComponents';

function Tracks() {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docLength, setDocLength] = useState(0);
  const { getAllTracks } = useFirebase();
  const { admin } = useAuth();

  useEffect(() => {
    setLoading(true);
    fetchAllTracks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAllTracks = async () => {
    await getAllTracks()
      .then((list) => {
        setDocLength(list.docs.length);

        list.docs.forEach((doc) => {
          let path = doc.id.toLowerCase();
          tracks.push({ ...doc.data(), id: doc.id, path: path });
        });
        setTracks(tracks);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <div>
      <Col>
        {admin && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <AddTrack docLength={docLength} />
            <DeleteTrack />
          </div>
        )}
        {!loading &&
          tracks.map((track) => (
            <Row className='justify-content-center d-flex align-items-center ml-2 mr-2 mt-2'>
              <div key={track.id}>
                <Button
                  style={{ height: '45px', width: '700px' }}
                  variant='outline-primary'
                  className='w-30 mt-1 mr-2'
                  as={Link}
                  to={ROUTES.TRACKS.concat('/', track.path)}
                  href={ROUTES.TRACKS.concat('/', track.path)}
                >
                  {track.name}
                </Button>
              </div>
            </Row>
          ))}
      </Col>
    </div>
  );
}

export default Tracks;
